//      
import ReactPiwik from "react-piwik";
import BaseTracker from "./BaseTracker";

export default class PiwikTracker extends BaseTracker {
	constructor(trackingId        , trackingHostUrl        , withEcommerce          = false) {
		super(trackingId, withEcommerce);
		this.tracker = new ReactPiwik({
			siteId: this.trackingId,
			jsFilename: this.trackingId + ".js",
			url: trackingHostUrl
		});
	}

	handleGenericEvent(cat        , action        , label     ) {
		ReactPiwik.push(["trackEvent", `${cat} ${action}`, label]);
	}

	handleOrderEvent(id        , revenue        ) {
		ReactPiwik.push([`${this.eventPrefix}SL_purchased`, id, revenue]);
	}

	handleItemEvent(id        , name        , articleNumber        , price        ) {
		ReactPiwik.push([`${this.eventPrefix}add to cart`, id, price]);
	}
}
